import React from "react";

// "see FAQ" is a link to a new page

const CCAlaCartRoyaltyFree = () => {
    return (
        <>
            No attribution required. For license info, see{" "}
            <a href="/legal/terms-of-use/#photo-licenses" target="_blank">
                FAQ
            </a>
            .
        </>
    );
};

export default CCAlaCartRoyaltyFree;
